
import actions from './actions'
import mutations from './mutations'
import { state } from './state'

export default function extendProduct (storeProduct) {
  storeProduct.actions = { ...storeProduct.actions, ...actions }
  storeProduct.state = { ...storeProduct.state, ...state(storeProduct) }
  storeProduct.mutations = { ...storeProduct.mutations, ...mutations }
  return storeProduct
}
